var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientsIconFig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#5FBDD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5714 25.4616V23.2051C21.5714 20.7128 19.9405 18.6923 17.9286 18.6923H10.6429C8.63096 18.6923 7 20.7128 7 23.2051V25.4616",
    fill: "#F7FDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5714 25.4616V23.2051C21.5714 20.7128 19.9405 18.6923 17.9286 18.6923H10.6429C8.63096 18.6923 7 20.7128 7 23.2051V25.4616H21.5714Z",
    stroke: "#F7FDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2857 15.3077C16.416 15.3077 18.1429 13.6029 18.1429 11.5C18.1429 9.39708 16.416 7.69232 14.2857 7.69232C12.1555 7.69232 10.4286 9.39708 10.4286 11.5C10.4286 13.6029 12.1555 15.3077 14.2857 15.3077Z",
    fill: "#F7FDFF",
    stroke: "#F7FDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2042 25.4616V22.5974C27.2028 20.758 25.8572 18.6923 23.2858 18.6923",
    stroke: "#F7FDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7142 8.53848C22.9999 8.53848 24.1428 10.4325 24.1428 12.1222C24.1428 13.8119 22.9999 15.3077 20.7142 15.3077",
    stroke: "#F7FDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsIconFig);
export default __webpack_public_path__ + "static/media/PatientsIconFig.d0ba6f6129dfea218cfb5f67582957b4.svg";
export { ForwardRef as ReactComponent };